import React from 'react';
import { useLanguage } from './LanguageContext';
import { Clock } from 'lucide-react';
export function Hours() {
  const {
    t
  } = useLanguage();
  return <div className="bg-brand-deep text-white rounded-2xl p-8 shadow-xl relative overflow-hidden" data-id="element-143">
      <div className="absolute top-0 right-0 -mt-10 -mr-10 w-40 h-40 bg-brand-teal opacity-20 rounded-full blur-3xl" data-id="element-144"></div>

      <div className="flex items-center gap-3 mb-6" data-id="element-145">
        <Clock className="w-6 h-6 text-brand-sky" data-id="element-146" />
        <h3 className="text-2xl font-bold" data-id="element-147">{t('hours.title')}</h3>
      </div>

      <div className="space-y-4 relative z-10" data-id="element-148">
        <div className="flex justify-between items-center border-b border-white/10 pb-2" data-id="element-149">
          <span className="text-brand-sky font-medium" data-id="element-150">
            {t('hours.mon_fri')}
          </span>
          <span className="font-semibold" data-id="element-151">7:30 AM – 7:00 PM</span>
        </div>
        <div className="flex justify-between items-center border-b border-white/10 pb-2" data-id="element-152">
          <span className="text-brand-sky font-medium" data-id="element-153">{t('hours.sat')}</span>
          <span className="font-semibold" data-id="element-154">7:30 AM – 3:00 PM</span>
        </div>
        <div className="flex justify-between items-center" data-id="element-155">
          <span className="text-brand-sky font-medium" data-id="element-156">{t('hours.sun')}</span>
          <span className="font-semibold text-white/60" data-id="element-157">
            {t('hours.closed')}
          </span>
        </div>
      </div>
    </div>;
}